<section class="order-details">
  <section class="text-center p-4 semi-bold-text bg-pale-blue">
    <label class="heading-color">Order Number: </label>{{orderDetails?.id}}
  </section>
  <section class="row p-3 bg-light-blue">
    <div class="col-md col-6 mb-3 mb-sm-0">
      <label class="medium-text d-block">Claim Number</label>
      <label>{{orderDetails?.claimNumber}}</label>
    </div>
    <div class="col-md col-6 mb-3 mb-sm-0">
      <label class="medium-text d-block">Date of Incident</label>
      <label>{{orderDetails?.dateOfIncident}}</label>
    </div>
    <div class="col-md col-6 mb-3 mb-sm-0">
      <label class="medium-text d-block">Carrier Name</label>
      <label>{{orderDetails?.carrierName}}</label>
    </div>
    <div class="col-md col-6 mb-3 mb-sm-0">
      <label class="medium-text d-block">Type of Order</label>
      <label>{{orderDetails?.typeOfOrder}}</label>
    </div>
    <div class="col-md col-6 mb-3 mb-sm-0">
      <label class="medium-text d-block">Service Level</label>
      <label>{{orderDetails?.serviceLevel}}</label>
    </div>
    <div class="col-md col-6 mb-3 mb-sm-0">
      <label class="medium-text d-block">Ordered Date</label>
      <label>{{orderDetails?.orderedDate}}</label>
    </div>
  </section>
  <p-tabs value="0" class="p-3">
    <p-tablist>
      <p-tab value="0">Records</p-tab>
      <p-tab value="1">General Information</p-tab>
      <p-button tabIndex="0" class="need-help-btn" styleClass="pe-0" (click)="needHelp()" [link]="true"> Need
        help?</p-button>
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel value="0">
        <div class="d-flex flex-row justify-content-between pb-3">
          <p-button class="invisible" aria-label="Download All" label="Download All" tabIndex="0" (click)="downloadAll()" [disabled]="!hasDocs()" />
          <div class="d-flex flex-row gap-4">
            <p-button aria-label="Collapse All" label="Collapse All" tabIndex="0" icon="fa-solid fa-minimize"
              (onClick)="tableAction('collapseAll')" [link]="true" />
            <p-button aria-label="Expand All" label="Expand All" tabIndex="0" icon="fa-solid fa-maximize"
              (onClick)="tableAction('expandAll')" [link]="true" />
          </div>
        </div>
        <div>
          <app-record-index-table [tableData]="recordRequests" (tableAction)="tableAction($event)" [isTableLoading]="isOrderLoading" [isDocumentsLoading]="isDocumentsLoading"></app-record-index-table>
        </div>
      </p-tabpanel>
      <p-tabpanel value="1">
        <app-order-details-general-information [orderDetails]="orderDetails" [orderData]="orderData" [documents]="orderDocuments" (tableAction)="tableAction($event)"></app-order-details-general-information>
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</section>


<!-- add dialogs here -->
<app-modal [header]="'Need Help'" [(showDialog)]="showHelpModal" [acceptLabel]="'CLOSE'"
  (acceptModalClick)="showHelpModal = false" class="">
  <app-need-help-modal></app-need-help-modal>
</app-modal>